import _ from "underscore";
import {WorkflowStatusType} from "../../constants";
import {arrayToSet} from "../../../atUtils";

export const convertToData = (filter) => {
    return {
        allSelected: filter.allSelected,
        statusTypes: Object.keys(filter.statusTypes),
        statusIds: Object.keys(filter.statusIds)
    };
}

export const convertToFilter = (data) => {
    return {
        allSelected: data.allSelected,
        statusTypes: arrayToSet(data.statusTypes),
        statusIds: arrayToSet(data.statusIds)
    };
}

export const OPEN_FILTER = {
    allSelected: false,
    statusTypes: [WorkflowStatusType.OPEN],
    statusIds: [],
};

export const COMPLETED_FILTER = {
    allSelected: false,
    statusTypes: [WorkflowStatusType.COMPLETED],
    statusIds: [],
};

export const ALL_FILTER = {
    allSelected: true,
    statusTypes: [],
    statusIds: [],
};

export const isAll = (filter) => {
    return filter.allSelected ||
           (filter.statusTypes.includes(WorkflowStatusType.OPEN) && filter.statusTypes.includes(WorkflowStatusType.COMPLETED))
}

const isOneTypeSelection = (filter, type) => {
    return isTypeSelected(filter, type) && filter.statusTypes.length === 1 && filter.statusIds.length === 0
}

const isTypeSelected = (filter, type) => {
    return !filter.allSelected && filter.statusTypes.includes(type)
}

export const isOnlyOpenType = (filter) => {
    return isOneTypeSelection(filter, WorkflowStatusType.OPEN)
}

export const isOpenTypeSelected = (filter) => {
    return isTypeSelected(filter, WorkflowStatusType.OPEN)
}

export const isOnlyCompletedType = (filter) => {
    return isOneTypeSelection(filter, WorkflowStatusType.COMPLETED)
}

export const isCompletedTypeSelected = (filter) => {
    return isTypeSelected(filter, WorkflowStatusType.COMPLETED)
}

export const isOnlyDirectlySelectedStatuses = (filter) => {
    return !filter.allSelected && filter.statusTypes.length === 0 && filter.statusIds.length > 0
}

export const countStatuses = (filter, statusesMap) => {
    const statusesList = Object.values(statusesMap)
    if (isAll(filter))
        return statusesList.length;

    let count = 0;
    for (let type of filter.statusTypes) {
        count += statusesList.filter((status) => status.type === type).length;
    }
    count += filter.statusIds.length;
    return count;
}

export const isFiltersEqual = (filter1, filter2) => {
    if (isAll(filter1) && isAll(filter2))
        return true;

    if (isAll(filter1) || isAll(filter2))
        return false;

    return _.isEqual(filter1, filter2);
}


// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/statusFilter/utils.js